import { observable } from 'mobx';
// import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import useMount from '@src/utils/hooks/use-mount';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import vhCheck from 'vh-check';
import getRemScale from '@src/utils/get-rem-scale';
import { useEffect } from 'react';
const pageLocalesData = getPageLocalesData();
const textInfo = pageLocalesData.main.fiveSection;

class FiveSectionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  @observable isActive = false;

  // 当前角标
  @observable currentIndex = 0;
  // 被触摸
  @observable isTouch = false;

  coordinateList = [
    {
      id: 'Cargo Rocket Beacon',
      name: '运输火箭信标',
      text: textInfo[0].content_text,
      imgOn: require('./images/dahuojian.png'),
      imgCenter: require('./images/equipment/dahuojian.png')
    },
    {
      id: 'Service Depot Beacon',
      name: '修理站信标',
      text: textInfo[1].content_text,
      imgOn: require('./images/xiulizhan.png'),
      imgCenter: require('./images/equipment/xiuli.png')
    },
    {
      id: 'Weapon Airdrop Beacon',
      name: '武装货柜信标',
      text: textInfo[2].content_text,
      imgOn: require('./images/wuzhaung.png'),
      imgCenter: require('./images/equipment/wuzhaung.png')
    },
    {
      id: 'racon beacon',
      name: '侦察信标',
      text: textInfo[3].content_text,
      imgOn: require('./images/zhencha.png'),
      imgCenter: require('./images/equipment/zhencha.png')
    },
    {
      id: 'DECOY BEACON',
      name: '诱饵装置信标',
      text: textInfo[4].content_text,
      imgOn: require('./images/youer.png'),
      imgCenter: require('./images/equipment/youer.png')
    },
    {
      id: 'Summoning Beacon',
      name: '召请信标',
      text: textInfo[5].content_text,
      imgOn: require('./images/zhaoqing.png'),
      imgCenter: require('./images/equipment/zhaoqing.png')
    }
  ];

  currentIndexChange = index => {
    this.currentIndex = index;
    // console.log(this.currentIndex);
  };

  use() {
    useMount(() => {
      const textBox = document.getElementById('text_Box');

      if (textBox) {
        textBox.addEventListener(
          'touchmove',
          function (event) {
            // alert('123');
            event.stopPropagation(); // 阻止事件传播，防止事件穿透
          },
          { passive: false }
        );
      }
    });
    useEffect(() => {
      try {
        const vhCheckResult = vhCheck();
        const remScale = getRemScale();
        this.vhOffset = (vhCheckResult?.offset || 0) * remScale;
      } catch (e) {
        console.error(e);
      }
    }, []);
  }
}

export default FiveSectionStore;
